import React, { useState } from "react";
import "./SelectionToggle.css";

const SelectionToggle = ({ set, selected, setSelected, options }) => {
  const [activeSelected, setActiveSelected] = useState(false);

  const toggle = () => setActiveSelected((prevState) => !prevState);

  const handleItemClick = (item) => {
    setSelected(item);
    toggle();

    if (item.toLowerCase() === "active") {
      set("active");
    } else if (item.toLowerCase() === "not active") {
      set("notActive");
    } else {
      set(item);
    }
  };

  function displayItem(item) {
    if (item === "active") {
      return "Active";
    }
    if (item === "notActive") {
      return "Not active";
    } else {
      return item;
    }
  }

  return (
    <div className="selection-toggle-container">
      <div
        className="custom-select"
        onMouseEnter={() => setActiveSelected(true)}
        onMouseLeave={() => setActiveSelected(false)}
      >
        <div
          className={`select-selected ${
            activeSelected ? "select-arrow-active" : ""
          }`}
        >
          {displayItem(selected)}
        </div>
        <div className="select-items">
          {activeSelected &&
            options.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleItemClick(item)}
                  className={`${item === selected ? "same-as-selected" : ""}`}
                >
                  {displayItem(item)}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default SelectionToggle;
